/** Core Plugin 基础集合工厂：独立模块，仅依赖 10 个基础插件，供主入口预设与子入口复用 */

import type { Plugin } from '@/shared/types/plugin'
import { CameraPlugin } from './camera/CameraPlugin'
import { CharacterPlugin } from './character/CharacterPlugin'
import { ControlPlugin } from './control/ControlPlugin'
import { InputPlugin } from './input/InputPlugin'
import { PickingPlugin } from './picking/PickingPlugin'
import { RenderPlugin } from './render/RenderPlugin'
import { SelectionPlugin } from './selection/SelectionPlugin'
import { SharedOcclusionDepthPlugin } from './sharedOcclusionDepth/SharedOcclusionDepthPlugin'
import { SpatialQueryPlugin } from './spatial/SpatialQueryPlugin'
import { ViewPlugin } from './view/ViewPlugin'

/** 插件预设选项 */
export interface PluginPresetOptions {
  /** 是否让支持的资源加载器携带跨域 Cookie */
  withCredentials?: boolean
}

/** Core Plugin 的基础集合 */
export function corePlugins(options: PluginPresetOptions = {}): Plugin[] {
  return [
    new ViewPlugin(),
    new CameraPlugin(),
    new InputPlugin(),
    new ControlPlugin(),
    new PickingPlugin(),
    new SharedOcclusionDepthPlugin(),
    new SpatialQueryPlugin({ withCredentials: options.withCredentials }),
    new CharacterPlugin(),
    new SelectionPlugin(),
    new RenderPlugin(),
  ]
}
